export default {
  getCompletedTask: (state) => state.completedTask,
};
